var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7734 0.229424C7.0598 -0.0695789 7.53478 -0.0802508 7.83395 0.205986C8.133 0.492315 8.14348 0.967314 7.85738 1.26653L5.07125 4.17669L7.85641 7.08685C8.14272 7.38601 8.13298 7.86097 7.83395 8.14739C7.53478 8.43375 7.05984 8.423 6.7734 8.12395L4.03317 5.26067L1.29293 8.12395C1.00652 8.42302 0.531568 8.4337 0.232385 8.14739C-0.0667269 7.86096 -0.0764603 7.38603 0.209924 7.08685L2.9941 4.17669L0.208947 1.26653C-0.0772512 0.967295 -0.0667637 0.492335 0.232385 0.205986C0.531588 -0.0802112 1.00656 -0.0696397 1.29293 0.229424L4.03317 3.09173L6.7734 0.229424Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.42fb0ebd70e863614b5f471df3ddeade.svg";
export { ForwardRef as ReactComponent };